import React from "react";

const EmptyState = ({ icon: Icon, title, description, action, className = "" }) => {
  return (
    <div className={`flex flex-col items-center justify-center text-center py-8 md:py-16 px-4 md:px-6 ${className}`}>
      <div className="rounded-2xl border border-bookish-purple/10 bg-white shadow-sm p-6 md:p-10 max-w-md w-full">
        {Icon && (
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-bookish-purple/5">
            <Icon className="h-7 w-7 text-bookish-purple/40" />
          </div>
        )}
        {title && (
          <h2 className="text-lg sm:text-xl font-serif font-semibold text-bookish-purple mb-2">
            {title}
          </h2>
        )}
        {description && (
          <p className="text-sm text-bookish-purple/60 leading-relaxed">
            {description}
          </p>
        )}
        {action && <div className="mt-6">{action}</div>}
      </div>
    </div>
  );
};

export default EmptyState;
